import React, { useEffect, useState } from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';

import Icon from '../../common/UI/Icon';
import { BOARD_VIEW_MODS, BOARD_VIEW_WINDOW_SIZES } from '../../../configs/boardViewMode';

import styles from './header.less';
import { connect } from '../../StateProvider';

const BoardViewMode = (props) => {
  const { toggleColsWidthMode, colsMode, isWebForm } = props;
  const { t } = useTranslation();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [valueMode, setValueMode] = useState(colsMode);

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWindowWidth(newWidth);
      if (newWidth < BOARD_VIEW_WINDOW_SIZES.LARGE) {
        setValueMode(null);
      }
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setValueMode(colsMode);
  }, [colsMode]);

  const toggleMode = (mode) => {
    if (mode === BOARD_VIEW_MODS.SMALL) {
      if (windowWidth > BOARD_VIEW_WINDOW_SIZES.LARGE) {
        toggleColsWidthMode(mode);
        setValueMode(mode);
      } else return;
    } else if (mode === BOARD_VIEW_MODS.MEDIUM) {
      if (windowWidth > BOARD_VIEW_WINDOW_SIZES.MEDIUM) {
        toggleColsWidthMode(mode);
        setValueMode(mode);
      } else return;
    }
    toggleColsWidthMode(mode);
    setValueMode(mode);
  };

  if (isWebForm) return null;

  return (
    <div>
      <div className={styles.viewTabsContainer}>
        <label htmlFor="mode">{t('fieldTypes.object.mode.label')}</label>
        <Radio.Group id="mode" name="mode" defaultValue={valueMode} value={valueMode} className={styles.iconGroup}>
          <div title={t('buttons.oneColumn')}>
            <Radio.Button
              value={BOARD_VIEW_MODS.LARGE === valueMode && BOARD_VIEW_MODS.LARGE}
              onClick={() => toggleMode(BOARD_VIEW_MODS.LARGE)}
            >
              <Icon type="icon anticon-icon hardware-14" className={styles.BoardViewIcon} />
            </Radio.Button>
          </div>
          <div title={t('buttons.twoColumns')}>
            <Radio.Button
              value={BOARD_VIEW_MODS.MEDIUM === valueMode && BOARD_VIEW_MODS.MEDIUM}
              onClick={() => toggleMode(BOARD_VIEW_MODS.MEDIUM)}
              disabled={!(windowWidth > BOARD_VIEW_WINDOW_SIZES.MEDIUM)}
            >
              <Icon type="icon anticon-icon hardware-15" className={styles.BoardViewIcon} />
            </Radio.Button>
          </div>
          <div title={t('buttons.threeColumns')}>
            <Radio.Button
              value={BOARD_VIEW_MODS.SMALL === valueMode && BOARD_VIEW_MODS.SMALL}
              onClick={() => toggleMode(BOARD_VIEW_MODS.SMALL)}
              disabled={!(windowWidth > BOARD_VIEW_WINDOW_SIZES.LARGE)}
            >
              <Icon type="icon anticon-icon hardware-1" className={styles.BoardViewIcon} />
            </Radio.Button>
          </div>
        </Radio.Group>
      </div>
    </div>
  );
};

export default connect(
  BoardViewMode,
  {
    isWebForm: ['ui', 'isWebForm'],
  },
  (props, { isWebForm }) => ({
    ...props,
    isWebForm,
  }),
);
